import {
  type ChangeEvent,
  type KeyboardEvent,
  type ReactNode,
  type RefObject,
} from 'react'

import { IconSearch, Modal, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { LlmConversationConfirmationBannerStyled } from './styles/LlmConversationConfirmationStyled'
import { AiActionButton } from '../AiActionButton'
import {
  CommandInputFieldStyled,
  CommandInputWrapperStyled,
} from '../CommandInput'

export interface ILlmConversationConfirmationProps {
  query: string
  inputRef: RefObject<HTMLInputElement>
  title: ReactNode
  actionContent: ReactNode
  actionAriaLabel?: string
  actionAnalyticsId?: string
  onChange: (value: string) => void
  onEnter?: () => void
  onActionClick?: () => void
}

export const LlmConversationConfirmation = ({
  query,
  inputRef,
  title,
  actionContent,
  actionAriaLabel,
  actionAnalyticsId,
  onChange,
  onEnter,
  onActionClick,
}: ILlmConversationConfirmationProps) => {
  const intl = useProcurifyIntl()

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value)
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onEnter?.()
    }
  }

  return (
    <>
      <Modal.Content pt={0} pr={6} pb={0}>
        <CommandInputWrapperStyled>
          <IconSearch size={16} color='textSecondary' />
          <CommandInputFieldStyled
            ref={inputRef}
            type='text'
            value={query}
            placeholder={intl.formatMessage(messages.inputPlaceholder)}
            aria-label={intl.formatMessage(messages.inputAriaLabel)}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </CommandInputWrapperStyled>
      </Modal.Content>
      <Modal.Content pl={0.5} pt={0} pr={0.5} pb={1}>
        <LlmConversationConfirmationBannerStyled>
          <Text bold breakWord color='textPrimary'>
            {title}
          </Text>
          <AiActionButton
            content={actionContent}
            ariaLabel={actionAriaLabel}
            analyticsId={actionAnalyticsId}
            onClick={onActionClick}
          />
        </LlmConversationConfirmationBannerStyled>
      </Modal.Content>
    </>
  )
}
